import React from "react";
import { checkHotspotType } from "../ui/utils"

export default class HotspotSelector extends React.Component {
    constructor(props) {
        super();
        this.hotspots = props.geojson.features;
        this.state = { hotspotList: false }
        this.buildList.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.hotspots = nextProps.geojson.features;
        this.buildList();
    }

    buildList() {
        let hList = [];
        let hs = this.hotspots.filter(h => {
            return h.properties !== undefined
                && h.properties.title !== undefined
                && h.properties.audioLayer !== undefined
        })
        hs.sort((a, b) => a.properties.title.localeCompare(b.properties.title));
        for (const h in hs) {

            let hsProps = hs[h].properties;
            let colour;
            const selected = checkHotspotType(hsProps);
            switch (selected) {
              case "standard": colour = "#3388ff"; break;
              case "instructional": colour = "#111111"; break;
              case "background": colour = "#aaaaaa"; break;
              default: colour = "#33dd33"; break;
            }

            const backgroundColour = this.props.currentPopupOpen+"" === hsProps.hotspotId+"" ? "#ffaa33" : "#f9f9f9"

            hList.push(
                <tr key={hList.length}><td>
                    <button
                        style={{ height: "30px", width: "400px", backgroundColor: backgroundColour}}
                        className="prettyButton"
                        onClick={() => this.props.openPopup(hsProps.hotspotId)}
                    >
                        <div style={{ backgroundColor: colour, width: "25px", height: "25px", float: "left" }} />
                        <div style={{
                            height: "23px",
                            width: "300px",
                            marginLeft: "30",
                            textAlign: "left",
                            marginTop: "3px",
                            marginLeft: "40px"
                        }}>
                            {hsProps.title}
                        </div>
                    </button>
                </td></tr>
            );
        }
        this.setState({ hotspotList: hList });
    }

    render() {
        const { hotspotList } = this.state;
        if (hotspotList !== false) {
            return (
                <div style={{overflow: "scroll"}}>
                    <table>
                        <tbody>
                            {hotspotList}
                        </tbody>
                    </table>
                </div>
            );
        } else {
            this.buildList();
            return <div />
        }
    }
}
